import { addListener, createHook, type Hook } from "../../utilities/hooks";
import {
    type ToWorkerMessage,
    type AppendIdArgs,
    type FromWorkerMessage,
    type AppendIdCallback,
} from "./types";

const worker = new Worker(new URL("./worker.ts", import.meta.url), {
    type: "classic",
});

function postMsg(msg: ToWorkerMessage) {
    worker.postMessage(msg);
}

const idListeners: Record<string, Hook<Parameters<AppendIdCallback>>> = {};

export function appendId(...args: AppendIdArgs): void {
    postMsg({ type: "appendId", args: [args[0]] });
    const key = typeof args[0] != "string" ? args[0].toString() : args[0];
    if (!idListeners[key]) {
        idListeners[key] = createHook<Parameters<AppendIdCallback>>();
    }
    addListener(idListeners[key], args[1]);
}

const connectionHook = createHook<[boolean]>();

export function onConnectionChange(callback: (v: boolean) => void) {
    addListener(connectionHook, callback);
}

worker.onmessage = (event) => {
    const data = event.data as FromWorkerMessage;
    switch (data.type) {
        case "updateId": {
            if (idListeners[data.id]) {
                idListeners[data.id].fire(data.id, data.stampData);
            }

            break;
        }
        case "connectionChange": {
            connectionHook.fire(data.state);
            break;
        }
    }
};
